<template>
  <div
    ref="keywordOption"
    class="keyword-option-holder"
  >
    <div
      v-if="type !== 'group' && type !== 'permissions'"
      ref="circleOption"
      class="keyword-circle"
    />
    <div
      ref="option"
      class="keyword-option"
    >
      {{ getOptionName() }}
    </div>
    <div
      v-show="removable"
      class="remove-btn"
      @click="handleOptionRemove"
    >
      <div class="circle-x" v-if="RMTPermission" >
        <img
          :src="require('@/assets/svg/SVG/x.svg')"
          alt="Bookmark/"
        >
      </div>
    </div>

    <div
      v-if="manageGroupMode && type === 'group'"
      class="group-edit-options"
    >
      <div
        class="remove-btn"
        @click.stop="handleGroupEdit"
      >
        <div class="circle-x">
          <img
            :src="require('@/assets/svg/SVG/edit.svg')"
            alt="Bookmark/"
          >
        </div>
      </div>
      <div
        class="remove-btn"
        @click.stop="handleGroupRemove"
      >
        <div class="circle-x">
          <img
            :src="require('@/assets/svg/SVG/x.svg')"
            alt="Bookmark/"
          >
        </div>
      </div>
    </div>

    <div class="sync-text" v-if="syncIsShowing" @click="handleSyncClick">SYNC</div>

    <div ref="bg" class="option-bg"></div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { gsap } from 'gsap';
import { useModalStore } from '@/store/ModalStore';
import {storeToRefs} from 'pinia/dist/pinia';
import {useResourceStore} from '@/store/ResourceStore';

export default {
  name: 'KeywordOption',
  props: [
    'option',
    'removable',
    'type',
    'keyword'
  ],
  setup () {
    const RMTStore = useRMTStore();
    const { RMTPermission, inMultiSelectionMode } = storeToRefs(RMTStore);
    const ModalStore = useModalStore();
    const ResourceStore = useResourceStore();
    return {
      RMTStore, RMTPermission, ModalStore, inMultiSelectionMode, ResourceStore,
    };
  },
  data () {
    return {
      syncIsShowing: false
    };
  },
  mounted () {
    this.handleUpdate();
    this.handleSyncStatus();
    if (!this.$props.removable) { return; }
    gsap.killTweensOf(this.$refs.keywordOption);
    if (this.$props.option.new) {
      gsap.from(this.$refs.keywordOption, {
        width: 0,
        duration: .6,
        ease: 'power3.out'
      });
      this.$props.option.new = false;
    }
  },
  updated () {
    this.handleSyncStatus();
  },
  computed: {
    manageGroupMode () {
      return this.RMTStore.manageGroupMode;
    }
  },
  methods: {
    getOptionName () {
      // todo: 'name' property is likely depricated - but this is a fix until we verify 'tag' is correct.
       let name = (this.$props.option.name !== undefined) ? this.$props.option.name : this.$props.option.tag;
      // todo: if 'tag' is undefined, we default to the groupName
      // todo: let o = this.$props.options
      // todo: possibly change to o.name || o.tag || o.groupName
      if (name === undefined) { name = this.$props.option.groupName; }
      return name;
    },
    textColor: function (color) {
      if (color === undefined) { return; }
      // Get background color hex value. '#' is optional.
      let hex = (color.charAt(0) === '#') ? color.substring(1, 7) : color;
      // Convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      // By this point, it should be 6 characters
      if (hex.length !== 6) {
        // throw new Error('Invalid HEX color.');
      }
      let r = parseInt(hex.slice(0, 2), 16),
          g = parseInt(hex.slice(2, 4), 16),
          b = parseInt(hex.slice(4, 6), 16);
      // Return light or dark class based on contrast calculation
      return ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#ffffff';
    },
    handleUpdate () {
      // TODO: call colors should be the same type (hex value as string)
      let color = this.$props.option.color;
      if (this.$refs.circleOption === undefined) { return; }
      gsap.set(this.$refs.circleOption, {
        backgroundColor: color,
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        marginRight: '8px'
      });
    },
    handleGroupEdit () {
      this.RMTStore.editGroup = this.$props.option;
      this.RMTStore.showAddGroup = true;
    },
    handleGroupRemove () {
      this.ModalStore.setModalObj({
        promptLabel: 'REMOVE GROUP',
        promptDescription: 'Are you sure you want to remove the group <b>' + this.getOptionName() + "</b>? <br><span class='note'>Note: All tags in this group will be set to uncategorized.</span>",
        buttonALabel: 'CONFIRM',
        buttonAFunc: this.removeGroup,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.cancelRemove
      });
      this.ModalStore.showModal('prompt');
    },
    removeGroup () {
      this.RMTStore.deleteGroup(this.$props.option.groupId);
      this.ModalStore.hideModal();
    },
    cancelRemove () {
      this.ModalStore.hideModal();
    },

    handleOptionRemove () {

      this.RMTStore.removeKeywordFromSelection(this.$props.option, this.$props.type);

    },

    handleSyncStatus () {

      if (this.RMTStore.inMultiSelectionMode && !this.$props.keyword) {

          if (!this.RMTStore.tagSelection[this.$props.type].shared.includes(this.$props.option[this.RMTStore.getTypeId(this.$props.type)])) {
            if (this.$refs.circleOption !== undefined) {this.$refs.circleOption.classList.add('not-synced');}
            this.$refs.bg.classList.add('sync-bg');
            this.syncIsShowing = true;
          }
          else {
            this.hideSyncAppearance();
          }

      }  else {
        // in single selection mode
        this.hideSyncAppearance();
      }
    },

    hideSyncAppearance () {

      if (this.$refs.circleOption !== undefined) {this.$refs.circleOption.classList.remove('not-synced');}
      this.$refs.bg.classList.remove('sync-bg');
      this.syncIsShowing = false;

    },

    handleSyncClick () {

      this.RMTStore.syncTag(this.$props.option, this.$props.type);

    }
  }
};
</script>

<style>
.note {
  font-size: .8em;
  font-weight: 700;
  color: #b90404;
}

.sync-text {
  font-weight: bold;
  font-size: .8em;
  margin-left: 10px;
  margin-right: 5px;
}

.option-bg {
  background-color: #dddddd;
  position: absolute;
  left: 0;
  top:0;
  width:100%;
 height: 30px;
  z-index: -1;
}
</style>

<style scoped>
.keyword-option-holder {
  position: relative;
  white-space: nowrap;
  cursor:pointer;
  padding-left: 10px;
  padding-right: 5px;
  height: 30px;
  margin: 3px;
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  color: black;
}
.keyword-option {
  padding-right: 5px;
  font-size: .78em;
}
.remove-btn {
  padding-left: 5px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-x {
  cursor: pointer;
  font-size: .8em;
  width: 13px;
  height: 13px;
  border-radius: 10px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  margin-right: 0px;

}
.group-edit-options {
  display: flex;
}

.not-synced {
  opacity: 0.5;
}

.sync-bg {
  background-color: #ffcbcb;
}
</style>